import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import UploadIcon from '@mui/icons-material/Upload';
import { useWatch } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages } from './disclosure/tiktok-disclosure-messages';

/**
 * TikTok publish form actions with disclosure tooltip.
 * Renders the submit button and shows a tooltip when the button is disabled
 * because commercial content disclosure is on but no option (your brand / third party / both) is selected.
 */
export function TikTokPublishFormActions() {
  const { $t } = useIntl();
  const discloseVideoContent = useWatch({ name: 'discloseVideoContent' });
  const brandContent = useWatch({ name: 'brandContent' });
  const brandOrganic = useWatch({ name: 'brandOrganic' });
  const missingDisclosureSelection =
    Boolean(discloseVideoContent) && !brandContent && !brandOrganic;

  return (
    <FormActionsMui
      separator
      saveIcon={<UploadIcon />}
      saveLabel={$t({
        id: 'socialExport.form.publish',
        defaultMessage: 'Publicar',
      })}
      cancel
      disableSubmitIfInvalid
      submitDisabledTooltip={
        missingDisclosureSelection ? $t(tiktokDisclosureMessages.selectAtLeastOneHint) : undefined
      }
    />
  );
}
